// bkExportDataThunks.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  GetBookkeepingExportDataRequest,
  GetBookkeepingExportDataResponse,
} from "../../models/BKExportData.model";

const API_BASE_URL = environment.apiUrl;

// פונקציית עזר להורדת קובץ
const downloadBlob = (blob: Blob, fileName: string) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export const BKExportDataThunks = createAsyncThunk<
  GetBookkeepingExportDataResponse,
  GetBookkeepingExportDataRequest,
  { rejectValue: string }
>(
  "bkExportData/GetBookkeepingExportData",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}BKHeshbonitExport/Export`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        // אם השרת מחזיר BadRequest עם גוף JSON
        const contentType = response.headers.get("content-type");
        if (contentType?.includes("application/json")) {
          const errorData: GetBookkeepingExportDataResponse =
            await response.json();
          return rejectWithValue(
            errorData.message || `שגיאה: ${response.status}`,
          );
        }
        throw new Error(`HTTP ${response.status}`);
      }

      // --- השרת מחזיר File (ZIP) ---
      const blob = await response.blob();

      // שליפת שם הקובץ מה-Content-Disposition
      const disposition = response.headers.get("content-disposition");
      let fileName = "heshbonitExport.zip";
      if (disposition) {
        const match = disposition.match(
          /filename\*?=(?:UTF-8'')?["']?(.+?)["']?(?:;|$)/i,
        );
        if (match) {
          fileName = decodeURIComponent(match[1]);
        }
      }

      // הורדה
      downloadBlob(blob, fileName);

      // החזרת הצלחה לסלייס
      return {
        success: true,
        message: `הקובץ ${fileName} יוצא בהצלחה`,
        data: null as any, // data לא רלוונטי כי קיבלנו Blob
      };
    } catch (error) {
      return rejectWithValue(
        error instanceof Error
          ? error.message
          : "שגיאה לא ידועה בייצוא לחשבשבת",
      );
    }
  },
);
